<template>
  <div class="container">
    <div class="title">欢迎使用到家</div>
    <div class="portal">
      <div class="portal-reg" @click="goto('/reg')">注册</div><div class="portal-login">登录</div>
    </div>
    <div class="weui-cells weui-cells_form">
        <div class="weui-cell weui-cell_select weui-cell_select-before">
            <div class="weui-cell__hd">
                
                <select class="weui-select" name="select2">
                    <option value="1">🇦🇺+61</option>
                </select>
            </div>
            <div class="weui-cell__bd">
                <input class="weui-input" type="tel" pattern="[0-9]"  placeholder="请输入手机号" v-model="phone" >
            </div>
        </div>
        <div class="weui-cell weui-cells_form">
            <div class="weui-cell__hd">
                <label class="weui-label">密码</label>
            </div>
            <div class="weui-cell__bd">
                <input class="weui-input" type="password" placeholder="请输入密码" v-model="password" />
            </div>
            <div class="weui-cell__ft">
              <span href="/forget" class="forget-password" @click="forgetPw()">忘记密码？</span>
            </div>
        </div>

    </div>
    <div class="btn-box">
      <div class="btn active" @click="loginSubmit()">登录</div>
    </div>
    <div class="warning" v-show="ajaxError()">⚠️登录失败：{{loginRes.data}}</div>
    <div class="warning" v-show="this.localError.length">⚠️{{localError.toString()}}</div>
    <transition name="fade">
        <div id="loadingToast" v-show="loadingToast">
            <div class="weui-mask_transparent"></div>
            <div class="weui-toast">
                <i class="weui-loading weui-icon_toast"></i>
                <p class="weui-toast__content">正在发送数据</p>
            </div>
        </div>
    </transition>
    
    <transition name="fade">
        <div id="successToast" v-show="successToast">
          <div class="weui-mask_transparent"></div>
          <div class="weui-toast">
              <i class="weui-icon-success-no-circle weui-icon_toast"></i>
              <p class="weui-toast__content">登陆成功</p>
          </div>
        </div>
    </transition>

  </div>
</template>

<script>
import qs from 'qs'

export default {
  name: 'login',
  data () {
    return {
      phone:'',
      password:'',
      localError: [],
      loadingToast: false,
      successToast: false,
      loginRes:{
        data:'',
        error_code:''
      },
      token:'',
    }
  },
  methods: {
    loginSubmit(){
      //本地验证表格函数
      if(this.checkSubmit()){
        let that = this;
        //「正在发送数据」弹窗提醒开启
        that.loadingToast = true;
        this.axios.post(this.apiURL()+'/globals/login', 
          qs.stringify(
            {
              account_name: this.phone,
              password: this.password
            }
          )
        )
        .then(function (response) {
          //「正在发送数据」弹窗提醒关闭
          that.loadingToast = false;
          //api返回的数据录入本地对象
          that.loginRes = response.data;
          //如果注册成功，跳转去注册成功页面
          if(that.loginRes.error_code==0){
            console.log(that.loginRes);
            //记录用户token值
            localStorage.token = that.loginRes.data.token;
            localStorage.member_phone = that.loginRes.data.user.phone;
            localStorage.member_email = that.loginRes.data.user.email;
            localStorage.member_name = that.loginRes.data.user.name;
            localStorage.invoices_title = that.loginRes.data.user.invoices_title;
            localStorage.invoices_address = that.loginRes.data.user.invoices_address;
            localStorage.tokenExpire = Math.floor(Date.now() / 1000) + 60*60*24*4.5;
            localStorage.removeItem('account_status');
            //登录成功弹窗
            //that.successToast = true;
            //setTimeout(function(){that.$router.push('/');}, 2000);
            if(that.$route.query.ordercallback){
              that.$router.push('/order-detail?id=' + that.$route.query.ordercallback);
            }
            else{
              that.$router.push('/login-success')
            };
          }
          console.log(response.data)
        })
        .catch(function (error) {
          that.loadingToast = false;
        });
      }
    },
    forgetPw(){
      let url = "/forget-password";
      if (this.phone){
        url = url + "?phone=" +this.phone;
      }
      this.goto(url);
    },
    checkSubmit(){
      this.localError = [];

      if (!this.phone) {
        this.localError.push("请填写手机号");
      } else if (this.phone.length!=9&&this.phone.length!=10&&this.phone.length!=11) {
        this.localError.push("请输入10位数字手机号");
      }
      if (!this.password) {
        this.localError.push('请输入8~20位字符密码');
      } else if (this.password.length<8 || this.password.length>20) {
        this.localError.push("请输入8~20位字符密码");
      }
      if (!this.localError.length) {
        return true;
      }
      else{
        return false;
      }
    },
    ajaxError(){
      if(this.loginRes.error_code!=0){
        return true;
      }
    },
  },
  components: {
  },
  mounted: function () {
    document.querySelector("html").classList.add("grey-background");
      if(this.$route.query.phoneNum){
        this.phone = this.$route.query.phoneNum;
      }
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  },
  created() {
    if(this.checkLogin()){
      this.$router.push('/profile');
    }
    if(this.$route.query.phone){
      this.phone = this.$route.query.phone;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.btn{
  margin-top:24px;
}

.title{
  margin:5vmax 0 2vmax 0;
  font-size:2.2em;
}

.terms{
  font-size:0.8em;
  color:#555;
  text-align:center;
  margin-top:20px;
}

.jump-link{
  color:#fe9567;
  text-align:center;
  margin-top:40px;
  text-shadow: 1px 1px 2px #fff
}
.forget-password{
  font-size: 14px;
  color: #336699;
}

.jump-link{
  color:#fe9567;
  text-align:center;
  margin-top:50px;
  text-shadow: 1px 1px 2px #fff
}

.warning{
  color:#555;
  text-align:center;
  margin-top:20px;
  padding:0 20px;
}

.container >>> .weui-cell_select-before{
  padding-right:0
}

.container >>> .weui-vcode-btn{
  color:#fe9567;
  width:110px;
}

.container >>> .weui-vcode-btn.disabled{
  color:#999;
}

.container >>> .weui-cells:after, .container >>> .weui-cells:before, .container >>> .weui-cell:before, .container >>> .weui-cell:after{
  z-index:0;
}

.portal{
  text-align:center;
  margin-bottom:30px;
  div{
    display:inline-block;
    font-size:1.4em;
  }
  .portal-reg{
    border-right:1px solid #bbb;
    padding:6px 50px;
    box-sizing:border-box;
  }
  .portal-login{
    border-bottom:4px solid #fe9567;
    margin:0 40px;
    padding:2px 10px;
    box-sizing:border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/login.vue